import { Eye, EyeOff, Sparkles } from "lucide-react";
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { InputBox } from "../CommonComponents/InputBox";
import { GetSession, SetSession } from '../CommonComponents/criptoUtils';
import Loader from './Loader';
import './LoginCSS.css';
import { getActiveProject } from "../CommonComponents/ProjectConfig";
import { fetchGlobalTranslations } from "../CommonComponents/Translations";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { GoogleLogin } from '@react-oauth/google';
export default function SignIn() {
    const activeProject = getActiveProject();
    const StaticToken ='AmqCLI6rg7olYF5gNsde1eRE';
    const source = 'web';
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [user, setUser] = useState({ userCode: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);
    const inputRefs = useRef([]);
    const [rememberMe, setRememberMe] = useState(false);
    const [configuration, setConfiguration] = useState(GetSession("cookies", 'clientConfigurationDetails') || {});

    const FillFormData = () => {
        let remember = localStorage.getItem('isClientRememberMe') === 'true';
        if (!remember) {
            try {
                const raw = GetSession("localstorage", 'isClientRememberMe');
                if (raw === true || raw === 'true') remember = true;
            } catch (e) { }
        }
        if (remember) {
            try {
                const savedUser = GetSession("localstorage", "clientUserDetails");
                if (savedUser) {
                    const parsedUser = typeof savedUser === 'object' ? savedUser : JSON.parse(savedUser);
                    setUser((prev) => ({ ...prev, ...parsedUser }));
                    setRememberMe(true);
                }
            } catch (err) {
                console.error("Error parsing clientUserDetails:", err);
            }
        }
    };

    const handleLogin = async (event) => {
        event.preventDefault();
        setBtnLoading(true);
        const data = {
            Token: StaticToken,
            UserCode: user.userCode !== '' ? user.userCode : '',
            Password: user.password,
            Source: source,
        };

        await fetch(`/api/UserLogin/Login`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' },
        })
            .then(async (response) => {
                const res = await response.json();
                if (res.status === 'SUCCESS') {
                    localStorage.removeItem('isClientRememberMe');
                    localStorage.setItem('isClientRememberMe', rememberMe ? 'true' : 'false');
                    if (rememberMe) {
                        SetSession('localStorage', 'clientUserDetails', user);
                    } else {
                        SetSession('localStorage', 'clientUserDetails', {});
                    }
                    await SetSession('cookies', 'clientUser', res);
                    setIsLoading(true);
                    // Fetch translations for the app after successful login
                    fetchGlobalTranslations();
                    setTimeout(() => {
                        setIsLoading(false);
                        navigate(location.state || '/Dashboard/Index');
                    }, 1000);
                    localStorage.setItem('ID', '1');
                } else {
                    setBtnLoading(false);
                    toast.error(res.message, { position: 'top-center' });
                    inputRefs.current[res.focus]?.focus();
                }
            })
            .catch((err) => {
                setBtnLoading(false);
                toast.error(String(err), { position: 'top-center' });
            });
    };

    const GetConfigurationDetails = async () => {
        const data = {
            "AuthToken": StaticToken
        };
        await fetch(`/api/UserLogin/GetConfigurationDetails`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' },
        })
            .then(async (response) => {
                const res = await response.json();
                if (res.status === 'SUCCESS') {
                    await SetSession('cookies', 'clientConfigurationDetails', res?.data);
                    setConfiguration(res?.data);
                } else {
                    NotificationSound('ERROR', res.message, res.focus, inputRefs, null, true, null, 'top-center');
                }
            })
            .catch((err) => {
                NotificationSound('ERROR', String(err), '', null, null, true, null, 'top-center');
            });
    };

    const handleGoogleLoginSuccess = async (credentialResponse) => {
        setBtnLoading(true);
        const data = {
            IdToken: credentialResponse.credential,
            Source: source,
        };
        await fetch(`/api/UserLogin/GoogleLogin`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' },
        })
            .then(async (response) => {
                const res = await response.json();
                if (res.status === 'SUCCESS') {
                    await SetSession('cookies', 'clientUser', res);
                    setIsLoading(true);
                    fetchGlobalTranslations();
                    setTimeout(() => {
                        setIsLoading(false);
                        navigate(location.state || '/Dashboard/Index');
                    }, 1000);
                    localStorage.setItem('ID', '1');
                } else {
                    setBtnLoading(false);
                    NotificationSound('ERROR', res.message, '', null, null, true, null, 'top-center');
                }
            })
            .catch((err) => {
                setBtnLoading(false);
                NotificationSound('ERROR', String(err), '', null, null, true, null, 'top-center');
            });
    };

    const handleGoogleLoginError = () => {
        NotificationSound('ERROR', 'Google login failed. Please try again.', '', null, null, true, null, 'top-center');
    };

    useEffect(() => {
        inputRefs.current['txtUserCode']?.focus();
        FillFormData();
        GetConfigurationDetails();
    }, []);

    const loginWithGoogle = configuration?.loginWithGoogle || false;

    return (
        <>
           <div className="min-h-screen">
                <div className="grid grid-cols-1 md:grid-cols-3 min-h-screen">
                    <div className="col-span-2 relative bg-[var(--theme-color)] p-20">
                        <div className="absolute hidden md:block bottom-0 left-0 w-full">
                            <img src={activeProject.loginBg} alt='' className='w-full' />
                            <div className="absolute top-0 left-0 w-full h-full" style={{ background: "linear-gradient(to bottom, var(--theme-color), transparent)" }}>

                            </div>
                        </div>

                        <div className="relative z-10">
                            {activeProject.establishedYear && (
                                <span className="px-4 py-2 bg-white text-[var(--theme-color)] font-semibold rounded-full inline-flex items-center gap-2"><Sparkles width={16}/> Established in {activeProject.establishedYear}</span>
                            )}
                            <h1 className="text-white text-4xl font-bold mt-4">{activeProject.loginHeadingLine1} <br/> {activeProject.loginHeadingLine2}</h1>
                            <p className="text-white text-base mt-3">{activeProject.description}</p>
                        </div>
                    </div>
                    <div>
                        <div className="w-full relative flex items-center justify-center px-6 py-12 overflow-hidden h-full">

                            {/* 🔥 Main Card */}
                            <div className="relative z-10 w-full max-w-md p-8 rounded-3xl">
                                <div className="mb-5">
                                    <img src={activeProject.logo} className="w-[240px] mx-auto" alt={`${activeProject.name} logo`} />
                                </div>
                                {/* Heading */}
                                <div className="mb-8 text-center fade-up">
                                    <h2 className="text-4xl font-bold text-slate-800">{activeProject.loginFormHeading}</h2>
                                    <p className="text-slate-800 text-md mt-1 font-bold">
                                       {activeProject.loginFormSubHeading}
                                    </p>
                                </div>

                                {/* Form */}
                                <form onSubmit={handleLogin} className="space-y-5">

                                    {/* User Code */}
                                    <InputBox
                                        id="txtUserCode"
                                        label="User Code"
                                        placeholder="Enter User Code"
                                        value={user.userCode}
                                        onChange={(e) =>
                                            setUser({ ...user, userCode: e.target.value })
                                        }
                                        inputrefs={inputRefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                inputRefs.current['txtPassword']?.focus();
                                            }
                                        }}
                                    />

                                    {/* Password */}
                                    <div className="relative">
                                        <InputBox
                                            id="txtPassword"
                                            label="Password"
                                            type={showPassword ? "text" : "password"}
                                            placeholder="Enter Password"
                                            value={user.password}
                                            onChange={(e) =>
                                                setUser({ ...user, password: e.target.value })
                                            }
                                            inputrefs={inputRefs}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleLogin(e);
                                                }
                                            }}
                                        />

                                        {/* 👁 Eye Icon */}
                                        <span
                                            onClick={() => setShowPassword(!showPassword)}
                                            className="absolute right-3 top-[22px] cursor-pointer text-slate-400 hover:text-[var(--theme-color)]"
                                        >
                                            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                        </span>
                                    </div>
                                    <div className="text-right"> <button type="button"
                                        onClick={() => navigate('/ForgotPassword')}
                                        className="text-sm text-[var(--theme-color)] hover:underline" > Forgot Password? </button> </div>
                                    {/* Button */}
                                    <button className="w-full bg-[var(--theme-color)] hover:bg-sky-700 text-white py-2 rounded-xl">
                                        {btnLoading ? 'Logging in...' : 'Login'}
                                    </button>
                                    {loginWithGoogle && (
                                        <>
                                            <div className="flex items-center gap-3 my-4">
                                                <div className="flex-1 h-px bg-slate-200"></div>
                                                <span className="text-xs text-slate-400">OR</span>
                                                <div className="flex-1 h-px bg-slate-200"></div>
                                            </div>

                                            <div className="flex justify-center">
                                                <GoogleLogin
                                                    onSuccess={handleGoogleLoginSuccess}
                                                    onError={handleGoogleLoginError}
                                                    width="100%"
                                                />
                                            </div>
                                        </>
                                    )}
                                    
                                </form>

                                {/* Footer */}
                                <p className="mt-8 text-center text-xs text-slate-400">
                                    © {new Date().getFullYear()} {activeProject.copyright}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Loader */}
            {isLoading && (
                <Loader text={activeProject.welcomeMessage} size='100px' img_path={activeProject.favicon} /> 
            )}

            <ToastContainer />
        </>
    );
}